import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import uniqid from 'uniqid'
import { Chip } from '../Chip/Chip'

import './ElementSelected.scss'

export const ElementSelected = ({
  items,
  children,
  className,
  enableRemove
}) => {
  const { current: uuid } = useRef(uniqid('b-elementselected-'))

  return (
    <div className={classnames('b-elementselected', className)}>
      <ul>
        {items.map(item => (
          <li key={uuid}>
            <Chip
              label={item.text}
              onClick={e => item.onClick()}
              icon={enableRemove ? 'times' : undefined}
            />
          </li>
        ))}
      </ul>
      {children}

    </div>
  )
}

ElementSelected.defaultProps = {}

ElementSelected.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      onClick: PropTypes.func,
      text: PropTypes.string
    })
  ),
  className: PropTypes.string,
  enableRemove: PropTypes.bool,
  children: PropTypes.any
}
